<template>
  <div>
    <!-- <p>Entrar ao vivo</p> -->
    <!-- <v-switch
      color="teal"
      v-model="getVideo.golive"
      inset
      :label="getVideo.golive ? 'Habilitado' : 'Desabilitado'"
      @change="(toggleGoLiveAction())"
    ></v-switch> -->
    <v-switch
      color="green"
      v-model="getVideo.golive"
      inset
      label="Entrar ao vivo"
      @change="toggle()"
    ></v-switch>
    <!-- <p>{{ getGoLiveEnabled }}</p> -->
    <!-- <p>{{ switch1 }}</p> -->
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from "vuex"

export default {
  name: 'GoLiveSwitch',
  data() {
    return {
      switch1: null,
      txt: 'lalalalal'
    }
  },
  computed: {
    ...mapGetters(['getGoLiveEnabled', 'getVideo']),
  },
   methods: {
    ...mapActions(['toggleGoLiveAction', 'test', 'getVideoAction', 'watchGoLiveAction']),
    ...mapMutations(['toggleGoLive']),

    toggle() {
      // if (this.getVideo) {
        // this.toggleGoLive()
        this.toggleGoLiveAction()
      // }
    }
  },
  updated() {
    // this.getVideoAction()
    
    this.watchGoLiveAction()
    this.switch1 = this.getGoLiveEnabled
  },
  beforeMount() {
    
    this.getVideoAction()
  },
  mounted() {
    // this.watchGoLiveAction()
    this.switch1 = this.getGoLiveEnabled
    // console.log(this.videoId)
    // this.test({
    //   txt: this.txt
    // })
  }
}
</script>